import React, { forwardRef } from 'react'
import { Carousel as AntCarousel } from 'antd'
import { CarouselProps, CarouselRef } from 'antd/lib/carousel'
import './carousel.ant.scss'

const Carousel = forwardRef<CarouselRef, CarouselProps>((props, ref) => {
  return (
    <div className="simple-carousel">
      <AntCarousel ref={ref} effect={'fade'} {...props}>
        {props.children}
      </AntCarousel>
    </div>
  )
})

Carousel.displayName = 'Carousel'

export default Carousel
